import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { ROUTE_LOGOUT } from '../../routes/constants';
import i18n from '../../i18n';

class LogoutMenuLink extends Component {
  render() {
    return (
      <Link className='activeUserChip' to={ROUTE_LOGOUT}>
        <ExitToAppIcon className='userChipIcon' />
        <span className='userChipText'>{i18n.t('logout').toUpperCase()}</span>
      </Link>
    );
  }
}

export default LogoutMenuLink;
